import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "redux/hooks";

import { selectEmployee } from "redux/slices/EmployeeSlice";

import { useMediaQuery } from "context/media/MediaContext";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

import { Panel, PanelHeader, Typography } from "components";
import { StyledFormWrapper, Row, Col } from "components/BaseComponents/Flex";
import Image, { ICONS } from "components/BaseComponents/Image";
import {
  StyledProfileCircleWrapper,
  StyledMobileWrapper,
} from "./EmployeeProfile.styles";
import { employeeAsync } from "redux/actions/Employee.action";
import { TokenInclude } from "helpers/GetToken";

const EmployeeProfile: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const dispatch = useAppDispatch();

  const empInfo = useAppSelector(selectEmployee);
  const token = TokenInclude();

  useEffect(() => {
    dispatch(employeeAsync(token));
  }, []);

  return (
    <Panel width='872px' marginTop={isMobile ? "-20px" : "0px"}>
      <PanelHeader />
      <StyledMobileWrapper>
        <StyledFormWrapper>
          <Row backgroundColor={DIGIPOSTHEME.colors.transparent}>
            <Col isDisplayFlex={true} justifyContent='center'>
              <StyledProfileCircleWrapper>
                <Image
                  alt='Menu Icon'
                  height={isMobile ? "24px" : "30px"}
                  srcSet={ICONS.TERMINALS}
                  width={isMobile ? "24px" : "30px"}
                />
                <Typography width='' size='18px' display='flex'>
                  {empInfo?.TotalMpos ?? 0}
                </Typography>
                <Typography width='' size='14px'>
                  {t("my_terminals")}
                </Typography>
              </StyledProfileCircleWrapper>
            </Col>
            <Col></Col>
            <Col isDisplayFlex={true} justifyContent='center'>
              <StyledProfileCircleWrapper>
                <Image
                  alt='Menu Icon'
                  height='40px'
                  srcSet={ICONS.EMPLOYEES}
                  width='40px'
                />
                <Typography width='' size='18px' display='flex'>
                  {empInfo?.ActiveUser ?? 0}
                </Typography>
                <Typography width='' size='14px'>
                  {t("active_agents")}
                </Typography>
              </StyledProfileCircleWrapper>
            </Col>
          </Row>
        </StyledFormWrapper>
      </StyledMobileWrapper>
    </Panel>
  );
};

export default EmployeeProfile;
